module.exports = __webpack_public_path__ + "assets/8d880f08b1a74a2a0c0dc57574b9a75d.mp3";